import React from "react"
import * as R from 'ramda'

import TextLift from './textLift';

const getElement = (section) => {
  if (R.path(['__typename'], section) === 'ContentfulArtikkelisivu') {
    return (
      <TextLift type="article" pageContent={section} key={R.path(['slug'], section)} />
    );
  }
  if (R.path(['__typename'], section) === 'ContentfulKohdesivu') {
    return (
      <TextLift type="premise" pageContent={section} key={R.path(['slug'], section)} />
    );
  }
  if (R.path(['__typename'], section) === 'ContentfulKategoriasivu') {
    return (
      <TextLift type="category" pageContent={section} key={R.path(['slug'], section)} />
    );
  }
};

const VerticalTextLift = ({liftContent}) => {
  return liftContent ? liftContent.map(reference => getElement(reference)) : null;
}

export default VerticalTextLift;